<template>
  <div>
    <div class="q-mb-md" v-if="!isFilter">
      <div class="row justify-ends">
        <div class="col-md-6">
          <q-btn
            icon="add"
            @click="newFormModalOpen=!newFormModalOpen"
            size="sm"
            flat
            class="no-shadow"
            color="secondary"
          >Add New {{ column.label | singular }}</q-btn>
        </div>
        <div class="col-md-6"></div>
      </div>
    </div>
    <q-select
      v-if="loaded && options && options.length"
      :value="value | mapKeys('id')"
      @input="handleChange"
      :options="options | qOptions(labelField)"
      :multiple="true"
      :align="column.align"
      hide-underline
      :color="!isFilter ? color: ''"
      :inverted-light="!isFilter"
      class="text-primary"
      clearable
      filter
      autofocus-filter
    ></q-select>
    <div
      class="q-pa-md q-ma-sm bg-grey-1 full-width scroll"
      style="max-height: 200px;"
      v-if="template !== 'filter'"
    >
      <div class="row inline group" v-for="(item, index) in value" :key="index">
        <q-chip
          closable
          square
          dense
          color="deep-purple-1"
          text-color="primary"
          icon="more_vert"
          @hide="handleRemove(index)"
          class="q-pa-xs"
          style="cursor: pointer"
          @click="handleClick(index)"
        >
          <span v-if="item && item.hasOwnProperty(labelField)">{{ item[labelField] }}</span>
          <span v-else>...</span>
        </q-chip>
      </div>
    </div>
    <div v-if="!isFilter">
      <!-- SHOW DETAILED INFO -->
      <q-modal
        v-model="modalOpen"
        content-classes="q-pa-lg"
        content-css="min-width: 70vw; max-width: 95vw"
      >
        <div v-if="modalData">
          <div class="q-pb-md">
            <span
              class="text-primary q-title"
            >{{ modalData[labelField] || `(no data for ${labelField})` }} Info</span>
          </div>
          <div class="q-pb-md">
            <model-card-view :model="modalData" :resource="relationResource">
              <div slot="actions" slot-scope="props">
                <q-btn class="full-width" color="primary" v-close-overlay label="Close"/>
              </div>
            </model-card-view>
          </div>
        </div>
      </q-modal>
      <!-- ADD NEW FORM -->
      <q-modal
        v-if="template === 'form' && relationResource !== parentResource"
        v-model="newFormModalOpen"
        content-classes="q-pa-lg"
        content-css="min-width: 70vw; max-width: 95vw"
        no-backdrop-dismiss
        no-esc-dismiss
      >
        <div class="fit">
          <q-btn
            flat
            icon="close"
            class
            style="top: 0; right: 0; position: relative; float: right"
            @click="newFormModalOpen=false"
          />
          <div v-if="newFormModalOpen">
            <h3
              class="q-display-1 text-secondary capitalize no-margin"
            >Add {{ column.label | singular }} to {{ parentResource | singular }}</h3>
            <base-form
              v-if="relationResource"
              :resource="relationResource"
              :parent-resource="parentResource"
              @add="handleNew"
              :is-modal="true"
            >
              <div slot="goback" class="full-width q-mt-md q-pb-lg">
                <q-btn
                  icon="close"
                  label="Cancel / Close"
                  color="grey-6"
                  @click="newFormModalOpen=false"
                  flat
                />
              </div>
            </base-form>
          </div>
        </div>
      </q-modal>
    </div>
  </div>
</template>
<script>
  import ModelCardView from '../list/ModelCardView'

  export default {
  name: 'SelectManyField',
  components: { ModelCardView },
  props: {
    color: {
      type: String,
      default: 'deep-purple-1'
    },
    value: {
      type: [Array, String],
      default: () => ''
    },
    column: {
      type: Object,
      required: true
    },
    _options: {
      type: Array,
      default: () => []
    },
    isFilter: Boolean,
    config: {
      type: Object,
      default: () => {}
    },
    template: {
      type: String,
      default: () => 'form'
    }
  },
  data () {
    return {
      loaded: false,
      isLoading: false,
      options: [],
      modalOpen: false,
      newFormModalOpen: false,
      modalData: null
    }
  },
  computed: {
    labelField () {
      return this.column.relation ? this.column.relation.label : this.column.label
    },
    resource () {
      return this.column.relation && this.column.relation !== 'self' ? this.column.relation.namespace : null
    },
    apiUrl () {
      return this.resource ? this.$store.state[this.resource].apiEndpoint : ''
    },
    relationResource () {
      return this.column.relation ? this.column.relation.namespace : null
    },
    parentResource () {
      return this.$route.meta.resource
    },
    optionsById () {
      return this.options.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }
  },
  methods: {
    handleClose () {
      this.view = 'default'
    },
    handleClick (index) {
      if (this.value[index]) {
        this.$set(this, 'modalData', this.value[index])
        this.modalOpen = true
      }
    },
    handleRemove (index) {
      console.log('>> emit REMOVE', {
        field: this.column.field,
        index: index,
        model: this.value[index]
      })
      this.$emit('remove', {
        field: this.column.field,
        index: index,
        model: this.value[index]
      })
    },
    handleNew (model) {
      this.newFormModalOpen = false
      this.$q.notify({
        message: `Added new ${this.column.label}`,
        type: 'positive'
      })
      this.$emit('add', this.column.field, model)
    },
    handleChange (list) {
      // console.log('>> change', list)
      this.$emit('input', list.map(id => this.optionsById[id]))
      // this.$emit('change', list.map(id => this.optionsById[id]))
      this.$emit('apply', list.map(id => this.optionsById[id]))
    },
    async fetchOptions () {
      if (this.resource && this.apiUrl) {
        try {
          let url = this.apiUrl
          url = url.replace('/api/', '/api/odata/')
          url = `${url}/paginate`
          // console.log(`-- init fetchAll ${this.resource}`)
          let params = {
            limit: 500,
            page: 1,
            sort: this.labelField || null,
            $filter: 'removalDate eq null'
          }
          if (this.config && this.config.hasOwnProperty('params')) {
            params = Object.assign({}, params, this.config.params)
          }
          const { data } = await this.$axios.get(url, {
            params
          })
          if (data && data.data) {
            this.$set(this, 'options', data.data)
            // console.log(`-- complete fetch --`)
          }
        } catch (e) {
          console.log(e.message)
        }
      }
    }
  },
  async created () {
    if (this._options && this._options.length) {
      this.$set(this, 'options', this._options)
    } else {
      await this.fetchOptions()
    }
    this.loaded = true
  }
}
</script>
